import axios from "axios";
import { User } from "../models";

export function configureUserApi(user: User) {
  axios.defaults.headers.common['x-uid'] = user.id;
}

export const API_PREFIX = '/1';
